import theme from 'base16/src/google'

export default theme
